module.exports = __webpack_public_path__ + "img/resource_mask3.07a4b2ae.png";